

let getAddOns = () => {
    let addOnList = [
        { value: 1, display: "Language Translation" },
        { value: 2, display: "SMS Notification" },
        { value: 3, display: "Email Alerts" },
        { value: 4, display: "Report Engine" },
        { value: 5, display: "Windows Application" },
        { value: 6, display: "iOS Application" }
    ]
    return addOnList;
}


export {
    getAddOns
}